import { render } from "./ImageDataSetting.vue?vue&type=template&id=099c30c8&scoped=true"
import script from "./ImageDataSetting.vue?vue&type=script&lang=js"
export * from "./ImageDataSetting.vue?vue&type=script&lang=js"

import "./ImageDataSetting.vue?vue&type=style&index=0&id=099c30c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099c30c8"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ImageDataSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "099c30c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('099c30c8', __exports__)) {
    api.reload('099c30c8', __exports__)
  }
  
  module.hot.accept("./ImageDataSetting.vue?vue&type=template&id=099c30c8&scoped=true", () => {
    api.rerender('099c30c8', render)
  })

}


export default __exports__